<div class="user-typing-wrapper">
    <div class="exchange-avatar">
        <img *ngIf="imgURL" [src]="imgURL" alt="Profile Photo">
        <app-svg-loader *ngIf="!imgURL" height="18px"
            url="assets/svg/user-solid.svg"></app-svg-loader>
      </div>
      <div class="bubbles" #bubblesContainer>
        <div class="bubble"></div>
        <div class="bubble"></div>
        <div class="bubble"></div>
      </div>
</div>
